import { useParams } from "react-router";
import { useContext, useEffect, useState, useRef } from "react";
import { fetchData, postData } from "../../../utils/fetch";
import { LanguageContext } from "../../../utils/lang_provider";
import 'react-quill/dist/quill.snow.css';
import TextEditor from "../../../utils/text_editor";
import { Button, message, Flex, Input } from "antd";
import { SaveOutlined } from '@ant-design/icons';
import UploadWidget from "./uploadWidget";
import ImageGalleryWidget from "./imageGalleryWidget";


export default function EditContentPage() {
  const { type, id } = useParams();
  const [object, setObject] = useState(null);
  const [title, setTitle] = useState("");
  const [newContent, setNewContent] = useState(null);
  const { language } = useContext(LanguageContext);

  const galleryRef = useRef();

  useEffect(() => {
    async function loadContent() {
      try {
        const data = await fetchData(`admin/${type}/${id}`, language);
        setObject(data);
        setTitle(data.title);
        setNewContent(data.content);
      } catch (error) {
        console.log("Could not load content page: " + error);
      }
    }
    loadContent();
  }, [type, id, language]);

  const updateContent = async () => {
    const newData = {
      id: object.id,
      language_id: object.language_id,
      title: title,
      content: newContent,
      author: object.author,
      created: object.created,
      updated: object.updated,
      status: object.status,
    };
    try {
      await postData(`admin/content/update/${type}`, newData, language);
      message.success("Successfully changed.");
    } catch (error) {
      message.error("An error occurred.");
    }
  };

  return (
    <Flex style={{ margin: "2% 5% 2% 5%" }} vertical gap={20}>
      <Input
        placeholder={title}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ marginBottom: "1rem" }}
      />
      <TextEditor value={newContent} setValue={setNewContent} />
      <ImageGalleryWidget ref={galleryRef} type={type} object={object} />
      <UploadWidget
        type={type}
        object={object}
        onPictureUpload={() => galleryRef.current?.refetch()}
      />
      <Button
        color="red"
        style={{ marginTop: "10px" }}
        onClick={updateContent}
      >
        <SaveOutlined /> Save
      </Button>
    </Flex>
  );
}
